import { CSSProperties, PropsWithChildren } from "react"
import { ButtonColor, ButtonSize, buttonColorSettings, buttonSizeSettings } from "./ButtonCommon";
import { classNames } from "../../../style/common";

export type ButtonProps = PropsWithChildren & {
    onClick: (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
    className?: string,
    style?: CSSProperties | undefined,
    title?: string | undefined,
    size?: ButtonSize,
    color?: ButtonColor,
    disabled?: boolean
};

export function Button(props: ButtonProps) {
    const buttonColor: ButtonColor = props.color ?? "emphasis";
    const buttonSize: ButtonSize = props.size ?? "md";

    const sizeClasses = buttonSizeSettings[buttonSize];
    const colorClasses = buttonColorSettings[buttonColor];

    return (
        <button
            onClick={(event) => props.onClick()}
            disabled={props.disabled}
            style={props.style}
            title={props.title}
            className={classNames(
                "disabled:cursor-not-allowed items-center",
                sizeClasses,
                colorClasses,
                props.className
            )}
        >
            {props.children}
        </button>
    )
}